module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-ulje-corokota-crnog-kima-8c77b63b955e3b4d84a12f10fe5e5281.png";